// view/compactWhenCramped.js — a button switches to its compact form (class is-compact, e.g. text → icon) when it has
// been squeezed so far that its own label keeps less than MIN_GAP_PX on each side, and back once its row is wider again
// than when it switched. Depends only on the button, its label and its row — not on any neighbour, and per language.
// Plan bugfix_2026-10-08_polishing-patch, phase schliesskreuze (3c). Consumer: the close button of the documents popup footer.

export const COMPACT_CLASS = 'is-compact';
export const MIN_GAP_PX = 5;         // label to button edge, each side, before the × takes over (normal: 10px)
const HYSTERESIS_PX = 8;             // back to text only with this much more row width — no flickering at the edge

function observeSize(el, onResize) {
    const observer = new ResizeObserver(onResize);
    observer.observe(el);
    return () => observer.disconnect();
}

// Returns release(). `observe` is injectable for the unit test.
export function compactWhenCramped({ row, button, label, observe = observeSize }) {
    let compactAtRowWidth = null;    // row width when it turned compact; null = text

    function update() {
        if (compactAtRowWidth === null && button.clientWidth < label.offsetWidth + 2 * MIN_GAP_PX) {
            compactAtRowWidth = row.clientWidth;
            button.classList.add(COMPACT_CLASS);
        } else if (compactAtRowWidth !== null && row.clientWidth >= compactAtRowWidth + HYSTERESIS_PX) {
            compactAtRowWidth = null;
            button.classList.remove(COMPACT_CLASS);
        }
    }

    // The button shrinks with the popup and when content arrives later (e.g. the video bar); the row tells when to go back.
    const releases = [observe(button, update), observe(row, update)];
    return () => releases.forEach((release) => release());
}
